export default function extractNumericChars(input: string): string {
    return input.replace(/\D/g, '');
}
